import { LambdaClientConfig } from './models';
import { LAMBDA_CLIENT_CONFIG } from './ts-sdit-data.module';
import { Inject } from '@angular/core';

export class Helper {
  constructor(
    @Inject(LAMBDA_CLIENT_CONFIG) private config: LambdaClientConfig
  ) { }

  genLambdaFunctionName(name: string): string {
    return `${this.config.functionNamePrefix}-${name}-${this.config.functionNameSuffix}`;
  }
}
